import { Answer } from '@verv-inc/js-questionnaire';
import { IAnalyticsEvent } from '@verv-inc/js-toolkit';
import {
	USER_ANSWER,
	USER_ANSWER_WORKTIME,
	USER_ANSWER_JOB,
	USER_ANSWER_SLEEP,
	USER_ANSWER_WATER,
	USER_ANSWER_TYPICAL_DAY,
	USER_ANSWER_BODY_TYPE,
	USER_ANSWER_LIFE_EVENT,
	USER_ANSWER_STAY_ON_TRACK,
	USER_ANSWER_IF_LIFE_CHANGE,
	USER_ANSWER_AILMENTS,
	USER_ANSWER_MEDICATIONS,
	USER_ANSWER_AGE,
	USER_ANSWER_OB_GOAL,
	USER_ANSWER_OB_PHYSICAL_BUILD,
	USER_ANSWER_OB_WATER,
} from './eventsAnswer';
import { appStore } from '@store';

interface GTMOnbordingQuestionEventParams {
	question: string;
	answer?: Answer | string;
}

export const GTMOnbordingQuestionEvent = {
	answerQuestion: (parameters: GTMOnbordingQuestionEventParams): IAnalyticsEvent => {
		const { question, answer } = parameters;
		return {
			name: 'onboarding_question',
			info: {
				quiz_question: question,
				quiz_answer: answer ?? 'no answer',
			},
		};
	},
};

export const NewGTMOnbordingQuestionEvent = {
	answerQuestion: (parameters: GTMOnbordingQuestionEventParams): IAnalyticsEvent => {
		const { question, answer } = parameters;
		const { answers } = appStore.surveyStore;
		const { unitsStore } = appStore;
		let eventAnswer;

		if (answer !== 'string' && answer !== undefined && answer.length === 1) {
			eventAnswer = answer[0];
		} else if (answer !== 'string' && answer !== undefined && answer.length > 1) {
			eventAnswer = answer;
		} else if (typeof answer === 'string') {
			eventAnswer = answer;
		} else {
			eventAnswer = 'continue';
		}

		switch (question) {
			case 'workTime': {
				for (const key in USER_ANSWER_WORKTIME) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_WORKTIME[key];
					}
				}
				break;
			}
			case 'jobActivity': {
				for (const key in USER_ANSWER_JOB) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_JOB[key];
					}
				}
				break;
			}
			case 'sleepPatterns': {
				for (const key in USER_ANSWER_SLEEP) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_SLEEP[key];
					}
				}
				break;
			}
			case 'waterIntake': {
				for (const key in USER_ANSWER_WATER) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_WATER[key];
					}
				}
				break;
			}
			case 'typicalDay': {
				for (const key in USER_ANSWER_TYPICAL_DAY) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_TYPICAL_DAY[key];
					}
				}
				break;
			}
			case 'bodyType': {
				for (const key in USER_ANSWER_BODY_TYPE) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_BODY_TYPE[key];
					}
				}
				break;
			}
			case 'lifeEvent': {
				for (const key in USER_ANSWER_LIFE_EVENT) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_LIFE_EVENT[key];
					}
				}
				break;
			}
			case 'stayOnTrack': {
				for (const key in USER_ANSWER_STAY_ON_TRACK) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_STAY_ON_TRACK[key];
					}
				}
				break;
			}
			case 'ifLifeChange': {
				for (const key in USER_ANSWER_IF_LIFE_CHANGE) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_IF_LIFE_CHANGE[key];
					}
				}
				break;
			}
			case 'ailments': {
				for (const key in USER_ANSWER_AILMENTS) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_AILMENTS[key];
					}
				}
				break;
			}
			case 'medications': {
				for (const key in USER_ANSWER_MEDICATIONS) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_MEDICATIONS[key];
					}
				}
				break;
			}
			case 'age': {
				for (const key in USER_ANSWER_AGE) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_AGE[key];
					}
				}
				break;
			}
			case 'ob_goal': {
				for (const key in USER_ANSWER_OB_GOAL) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_OB_GOAL[key];
					}
				}
				break;
			}
			case 'ob_physical_build': {
				for (const key in USER_ANSWER_OB_PHYSICAL_BUILD) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_OB_PHYSICAL_BUILD[key];
					}
				}
				break;
			}
			case 'ob_dream_body': {
				break;
			}
			case 'ob_water': {
				for (const key in USER_ANSWER_OB_WATER) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER_OB_WATER[key];
					}
				}
				break;
			}
			case 'ob_diet': {
				let fasting;
				if (answers?.intermittent_fasting) {
					fasting = answers?.intermittent_fasting[0] === 'true' ? 'yes' : 'no';
				}
				eventAnswer = `${eventAnswer}+fasting_${fasting}`;
				break;
			}
			case 'ob_height': {
				if (typeof eventAnswer === 'string') {
					const obj = JSON.parse(eventAnswer);

					let unitSistem;
					if (unitsStore.isMetrics) {
						unitSistem = 'metric';
						eventAnswer = JSON.stringify({
							height: obj.value[0].value,
							units: unitSistem,
						});
					} else {
						unitSistem = 'imperial';
						const cmValue = Math.round(
							Number(obj.value[0].value) * 30.48 + Number(obj.value[1].value) * 2.54,
						);
						eventAnswer = JSON.stringify({
							height: cmValue,
							units: unitSistem,
						});
					}
				}
				break;
			}
			case 'ob_current_weight': {
				if (typeof eventAnswer === 'string') {
					const obj = JSON.parse(eventAnswer);

					if (unitsStore.isMetrics) {
						eventAnswer = JSON.stringify({
							current_weight: obj.value,
							bmi: obj.bmi,
							bmi_group: obj.textBmi,
						});
					} else {
						const kgValue = Math.round(Number(obj.value) * 0.453592);
						eventAnswer = JSON.stringify({
							current_weight: kgValue,
							bmi: obj.bmi,
							bmi_group: obj.textBmi,
						});
					}
				}
				break;
			}
			case 'ob_target_weight': {
				if (typeof eventAnswer === 'string') {
					const obj = JSON.parse(eventAnswer);

					if (unitsStore.isMetrics) {
						eventAnswer = obj.value;
					} else {
						const kgValue = Math.round(Number(obj.value) * 0.453592);
						eventAnswer = kgValue;
					}
				}
				break;
			}
			case 'ob_occasion_date': {
				if (typeof eventAnswer === 'string' && eventAnswer !== 'continue') {
					const obj = JSON.parse(eventAnswer);
					const date = obj.value;
					const targetDate = new Date(date);
					const today = new Date();
					targetDate.setHours(0, 0, 0, 0);
					today.setHours(0, 0, 0, 0);
					const diffInMilliseconds = targetDate.getTime() - today.getTime();
					const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
					console.log(diffInDays);
					eventAnswer = diffInDays;
				}
				break;
			}
			case 'firstScreenCustom': {
				if (answers.age_v2) {
					eventAnswer = answers.age_v2[0] || 'continue';
				}
				break;
			}
			default: {
				for (const key in USER_ANSWER) {
					if (key === eventAnswer) {
						eventAnswer = USER_ANSWER[key];
					}
				}
			}
		}

		return {
			name: 'user_answers',
			info: {
				quiz_question: question,
				quiz_answer: eventAnswer,
			},
		};
	},
};
